import { PubSub } from 'stores/common/PubSub';
import { TableCellController } from 'stores/common/TableController';
import { ILocalStore } from 'stores/interfaces';

import {
  isTableFactoryStoreCommentUnselectEvent,
  isTableFactoryStoreCommentSelectEvent,
  TableFactoryStoreEventKind,
  TableFactoryStoreEvents,
} from './events';

/** PubSub для передачи событий внутри FactoryStore */
class TableFactoryPubSub implements ILocalStore {
  readonly pubSub = new PubSub<TableFactoryStoreEvents>();

  subscribeToCommentSelectEvent(
    callback: (payload: TableCellController) => void
  ): VoidFunction {
    return this.pubSub.subscribe(
      TableFactoryStoreEventKind.COMMENT_SELECT,
      (event) => {
        if (isTableFactoryStoreCommentSelectEvent(event)) {
          callback(event.payload.payload);
        }
      }
    );
  }

  subscribeToCommentUnselect(callback: VoidFunction): VoidFunction {
    return this.pubSub.subscribe(
      TableFactoryStoreEventKind.COMMENT_UNSELECT,
      (event) => {
        if (isTableFactoryStoreCommentUnselectEvent(event)) {
          callback();
        }
      }
    );
  }

  publishCommentSelectEvent(payload: TableCellController): void {
    this.pubSub.publish({
      kind: TableFactoryStoreEventKind.COMMENT_SELECT,
      payload: {
        payload,
      },
    });
  }

  publishCommentUnselectEvent(): void {
    this.pubSub.publish({
      kind: TableFactoryStoreEventKind.COMMENT_UNSELECT,
      payload: {},
    });
  }

  destroy() {
    this.pubSub.destroy();
  }
}

export default TableFactoryPubSub;
